import React from 'react'

import { observer } from 'mobx-react-lite'

import { useCopyStore, usePageview } from '../context/hooks'

import { ANALYTICS_PAGE_NAMES } from '../constants/Analytics'

import type { MicroInsightCardProps } from '../interfaces'
import MicroCardTemplate from '../MicroCardTemplate'
import { BeatMaterialIcon } from '../beaticons'

import { alpha, useTheme } from '@mui/material/styles'

export const ZeroStateCard: React.FC<MicroInsightCardProps> = ({
  ariaLabel,
  elevation,
  heightOverrides,
  onCardClick,
  showIcon,
  variant,
}) => {
  // *************** Context functions *********************
  const { onPageview } = usePageview()
  const { zeroStateCopy } = useCopyStore()
  const theme = useTheme()

  // ************** Use Effects Hooks **********************
  React.useEffect(() => {
    onPageview(ANALYTICS_PAGE_NAMES.MICRO_WIDGET_CAROUSEL_ZERO_STATE)
  }, [])

  return (
    <MicroCardTemplate
      ariaLabel={ariaLabel}
      description={zeroStateCopy.carousel_zero_state_description}
      elevation={elevation}
      heightOverrides={heightOverrides}
      icon={
        showIcon && (
          <BeatMaterialIcon bgColor={alpha(theme.palette.primary.main, 0.15)} name="lightbulb" />
        )
      }
      onCardClick={onCardClick}
      title={zeroStateCopy.carousel_zero_state_title}
      variant={variant}
    />
  )
}

export default observer(ZeroStateCard)
